export interface ExportColumn<T> {
  header: string;
  accessor: (row: T) => string | number | boolean | null | undefined;
}

function escapeCsvValue(value: string | number | boolean | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }
  let str = String(value);
  // Prevent CSV formula injection: Excel/Sheets interpret cells starting with
  // =, +, -, @, tab or CR as formulas. Prefix a single quote to force text.
  if (/^[=+\-@\t\r]/.test(str)) {
    str = `'${str}`;
  }
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportToCsv<T>(options: {
  fileName: string;
  columns: ExportColumn<T>[];
  rows: T[];
}): void {
  const { fileName, columns, rows } = options;

  const headerRow = columns.map((c) => escapeCsvValue(c.header)).join(',');
  const dataRows = rows.map((row) =>
    columns.map((c) => escapeCsvValue(c.accessor(row))).join(','),
  );

  const csv = [headerRow, ...dataRows].join('\r\n');

  const ts = new Date()
    .toISOString()
    .replace(/[:T]/g, '-')
    .replace(/\..+/, '');

  const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}-${ts}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
